import { useTranslation } from "react-i18next";
import { MapPinIcon } from "~/components/common/icons";
import type { PartySiteWithLocation } from "~/lib/types";

type Props = {
  sites: PartySiteWithLocation[];
};

const formatAddress = (
  location: PartySiteWithLocation["location"],
): string | null => {
  if (!location) return null;
  const parts = [
    location.address_line_1,
    location.address_line_2,
    location.city,
    location.region,
    location.postal_code,
    location.country,
  ].filter(Boolean);
  return parts.length > 0 ? parts.join(", ") : null;
};

export const PartySiteList = ({ sites }: Props) => {
  const { t } = useTranslation();

  if (sites.length === 0) return null;

  return (
    <div>
      <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-text-full">
        <MapPinIcon className="h-5 w-5 text-accent" />
        {t("MerchantDetail.locations")}
      </h2>
      <div className="mt-5 space-y-3">
        {sites.map(site => {
          const address = formatAddress(site.location);
          return (
            <div
              key={site.id}
              className="rounded-xl border border-border-shell/60 dark:border-transparent bg-surface-blank p-4 shadow-simple"
            >
              <h3 className="font-heading font-semibold text-text-full">
                {site.party_site_name}
              </h3>
              {address ? (
                <p className="mt-1.5 flex items-start gap-1.5 text-sm text-text-light">
                  <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0" />
                  {address}
                </p>
              ) : (
                <p className="mt-1.5 text-sm text-text-light">
                  {t("MerchantDetail.no-address")}
                </p>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
